import { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import SaloneeAbout from "../components/SaloneeAbout";
import Marquee from "../components/Marquee";
import Collection from "../components/Collection";
import Commissions from "../components/Commissions";
import Disciplines from "../components/Disciplines";
import Contact from "../components/Contact";
import { DEFAULT_ARTWORKS, DEFAULT_CONTENT } from "../lib/defaults";

export default function Home() {
  const [artworks, setArtworks] = useState(DEFAULT_ARTWORKS);
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
    axios
      .get(`${API}/artworks`)
      .then((r) => {
        if (Array.isArray(r.data) && r.data.length) setArtworks(r.data);
      })
      .catch(() => {});
    axios
      .get(`${API}/content`)
      .then((r) => {
        if (r.data) setContent({ ...DEFAULT_CONTENT, ...r.data });
      })
      .catch(() => {});
  }, []);

  return (
    <div className="grain relative min-h-screen overflow-x-clip bg-cream text-ink" data-testid="home-page">
      <Navbar content={content} />
      <main>
        <Hero />
        <About content={content} />
        <SaloneeAbout />
        <Marquee />
        <Collection artworks={artworks} content={content} />
        <Commissions />
        <Disciplines />
        <Contact content={content} />
      </main>
    </div>
  );
}
